import { Component, computed, input, signal } from '@angular/core';
import { FeatureFlag } from '@app/enums';
import { Role } from '@app/models/account/role.model';
import { PlatformModule } from '@app/platform.module';
import { AuthService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    template: `
        @if (shouldDisplay()) {
            <ui-banner variant="warning">
                <div>
                    <span>{{ 'payroll.kyc-kyb.roles-and-permissions.warning-banner' | translate }}</span
                    >&nbsp;<span
                        innerHTML="{{
                            'payroll.kyc-kyb.forMoreInfo.message'
                                | translate: { helpCenterUrl: 'payroll.kyc-kyb.forMoreInfo.helpCenterUrl' | translate }
                        }}"
                    ></span>
                </div>
            </ui-banner>
        }
    `,
    selector: 'app-kyc-kyb-role-warning',
    standalone: true,
    imports: [PlatformModule, TranslateModule],
})
export class KYCKYBRoleWarning {
    role = input.required<Role>();
    hasKYCKYBFeatureFlag = signal(false);

    shouldDisplay = computed(() => {
        if (!this.hasKYCKYBFeatureFlag()) {
            return false;
        }

        // Sometimes a role can have the accessPayroll permission even if the module is not assigned to the company
        // Therefore we need this additional check to ensure we don't show the banner
        if (!this.authService.hasPayrollAccess) {
            return false;
        }

        return this.role().permissions.some((permission) => permission.name === 'accessPayroll');
    });

    constructor(
        featureService: FeatureService,
        private authService: AuthService
    ) {
        featureService.has(FeatureFlag.KYC_KYB).then(this.hasKYCKYBFeatureFlag.set);
    }
}
